import apiArchives from '@/api/archives';
import apiSinglePost from '~/api/singlePost';
import apiWidgets from '@/api/widgets';
import apiTalker from '@/api/talker';
import apiWordPress from '@/api/wordpress';
import apiPreview from '@/api/preview';
import apiMissPrint from '@/api/missPrint';
import apiAdminActions from '~/api/adminActions';
import apiQuizPoll from '@/api/quizPoll';
import apiAdsForm from '~/api/adsForm';
import askQuestion from '~/api/askQuestion';
import apiReactions from '@/api/reactions';
import apiSearch from '@/api/search';

import type { IAPIRepositories } from '~/types/plugins/api.types';
import type { NuxtApp } from '#app';

export default defineNuxtPlugin((nuxtApp) => {
  const { $logger } = nuxtApp as NuxtApp;

  const api: IAPIRepositories = {
    archives: apiArchives({ $logger }),
    singlePost: apiSinglePost({ $logger }),
    widgets: apiWidgets({ $logger }),
    talker: apiTalker({ $logger }),
    wordPress: apiWordPress({ $logger }),
    preview: apiPreview({ $logger }),
    missPrint: apiMissPrint({ $logger }),
    adminActions: apiAdminActions({ $logger }),
    quiz: apiQuizPoll({ $logger }),
    adsForm: apiAdsForm({ $logger }),
    askQuestion: askQuestion({ $logger }),
    reactions: apiReactions({ $logger }),
    search: apiSearch({ $logger }),
  };

  $logger('🤙🏻 api-plugin', api);
  nuxtApp.provide('api', api);
});
